import { Button, Chip, FormHelperText, Grid, TextField, Tooltip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Field, Form, Formik } from 'formik';
import CustomPhoneNumber from 'input-component/PhoneNumber';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import * as Yup from 'yup';
import ProviderFirestoreService from '../services/ProvidersService';
import { MuiFileInput } from 'mui-file-input';

const ProvidersForm = ({ formikRef, setLoading, setSnackbarData }) => {
  const theme = useTheme();

  const initialValues = {
    partner: '',
    email: '',
    name: '',
    lastName: '',
    website: '',
    phone: '',
    tag: '',
    icon: null
  };

  const validationSchema = Yup.object().shape({
    partner: Yup.string().required('El campo "Partner" es requerido'),
    email: Yup.string().email('Ingrese una dirección de correo electrónico válida').required('El campo "Email" es requerido'),
    name: Yup.string().required('El campo "Nombre" es requerido'),
    lastName: Yup.string().required('El campo "Apellido" es requerido'),
    website: Yup.string().required('El campo "Website" es requerido'),
    phone: Yup.string().required('El campo "Teléfono" es requerido'),
    tag: Yup.string().required('El campo "Tag" es requerido')
  });

  const tagsOptions = [
    { tag: 'Socios estratégicos', detail: 'Socios estratégicos' },
    { tag: 'Partner / Socios /  Distribuidor calificado', detail: 'Partner / Socios /  Distribuidor calificado' },
    { tag: 'Terceros proveedores en el Google Cloud Marketplace', detail: 'Terceros proveedores en el Google Cloud Marketplace' }
  ];

  const resetFormHandler = () => {
    if (formikRef.current) {
      formikRef.current.resetForm({ values: initialValues });
    }
  };

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        try {
          setLoading(true);
          let result, successMessage, errorMessage;

          if (!values.id) {
            result = await ProviderFirestoreService.createProvider(values);
            successMessage = 'Proveedor agregado con exito!';
            errorMessage = 'Error al agregar pproveedor:';
          } else {
            result = await ProviderFirestoreService.updateProvider(values);
            successMessage = 'Proveedor actualizado con exito!';
            errorMessage = 'Error al actualizar proveedor:';
          }

          resetFormHandler();

          setSnackbarData({
            open: true,
            severity: result.error ? 'error' : 'success',
            message: result.error ? `${errorMessage} ${result.error.message}` : `${successMessage}`
          });
        } catch (error) {
          console.error(error);
          setSnackbarData({
            open: true,
            severity: 'error',
            message: 'Error inesperado'
          });
        } finally {
          setLoading(false);
        }
      }}
    >
      {({ values, errors, setFieldValue }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Field
                name="partner"
                as={TextField}
                sx={{ ...theme.typography.customInput }}
                label="Nombre de Partner"
                variant="outlined"
                fullWidth
              />
              <FormHelperText error id="standard-weight-helper-text--register">
                {errors.partner}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field name="email" as={TextField} sx={{ ...theme.typography.customInput }} label="email" variant="outlined" fullWidth />
              <FormHelperText error id="standard-weight-helper-text--register">
                {errors.email}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field name="name" as={TextField} sx={{ ...theme.typography.customInput }} label="Nombre" variant="outlined" fullWidth />
              <FormHelperText error id="standard-weight-helper-text--register">
                {errors.name}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field
                name="lastName"
                as={TextField}
                sx={{ ...theme.typography.customInput }}
                label="Apellido"
                variant="outlined"
                fullWidth
              />
              <FormHelperText error id="standard-weight-helper-text--register">
                {errors.lastName}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field name="website" as={TextField} sx={{ ...theme.typography.customInput }} label="Website" variant="outlined" fullWidth />
              <FormHelperText error id="standard-weight-helper-text--register">
                {errors.website}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={6}>
              <PhoneInput
                defaultCountry={'CO'}
                label="Teléfono"
                margin="normal"
                name="phone"
                type="text"
                value={values.phone}
                onChange={(e) => setFieldValue('phone', e)}
                sx={{ ...theme.typography.customInput }}
                inputComponent={CustomPhoneNumber}
              />
              <FormHelperText error id="standard-weight-helper-text--register">
                {errors.phone}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Field
                name="icon"
                as={MuiFileInput}
                sx={{ ...theme.typography.customInput }}
                placeholder="Icono"
                variant="outlined"
                type="file"
                inputProps={{ accept: 'image/*' }}
                onChange={(file) => setFieldValue('icon', file)}
                fullWidth
              />
              <FormHelperText error id="standard-weight-helper-text--register">
                {errors.icon}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Typography variant="caption">Tag de proveedor</Typography>
              <Grid container spacing={2}>
                {tagsOptions.map((option, index) => (
                  <Grid item key={index}>
                    <Tooltip title={option.detail} key={index}>
                      <Chip
                        label={option.tag}
                        variant={option.tag === values.tag ? 'filled' : 'outlined'}
                        color="primary"
                        onClick={() => setFieldValue('tag', option.tag)}
                      />
                    </Tooltip>
                  </Grid>
                ))}
              </Grid>
              <FormHelperText error id="standard-weight-helper-text--register">
                {errors.tag}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={12}>
              {values.id ? (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                      Editar
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button onClick={resetFormHandler} variant="contained" style={{ backgroundColor: 'gray' }} fullWidth>
                      Cancelar Edicion
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                <Button type="submit" variant="contained" color="primary" fullWidth>
                  Guardar
                </Button>
              )}
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default ProvidersForm;
